import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Tailwind CSS class name merger utility
 * Combines clsx for conditional classes with tailwind-merge for deduplication
 *
 * @example
 * ```tsx
 * cn('px-4 py-2', { 'bg-blue-500': isActive })
 * // Returns: "px-4 py-2 bg-blue-500"
 *
 * cn('px-4', 'px-8') // tailwind-merge handles conflicts
 * // Returns: "px-8"
 * ```
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
